<template>
  <div
    id="captcha-policy"
  >
    <p
      class="text-body-2"
    >
      {{ $t('footer.captcha-label') }}
      <a
        href="https://policies.google.com/privacy"
      >
        {{ $t('footer.captcha-privacy-link') }}
      </a>
      {{ $t('footer.captcha-label-and') }}
      <a
        href="https://policies.google.com/terms"
        rel="noreferrer"
        target="_blank"
      >
        {{ $t('footer.captcha-terms-link') }}
      </a>
      {{ $t('footer.captcha-label-apply') }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'CaptchaPolicy'
}
</script>

<style lang="scss" scoped>
</style>
